import { makeStyles } from '@mui/styles';

import { methodBackogrundColors } from '../disbursmentRow';

export const useStyles = makeStyles((theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2),
    overflowWrap: 'break-word',
    borderColor: theme.palette.border.line,
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  headerCentered: {
    alignItems: 'center',
  },
  description: {
    flex: 1,
    minWidth: 0,
    color: theme.palette.primary.darker,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'capitalize',
    overflowWrap: 'anywhere',
  },
  amount: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  money: {
    color: theme.palette.primary.darker,
    fontWeight: theme.typography.fontWeightMedium,
    fontVariantNumeric: 'tabular-nums',
  },
  placeholder: {
    letterSpacing: theme.spacing(0.25),
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
  },
  method: ({ code }: { code: string }) => ({
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.darker,
    textTransform: 'capitalize',
    backgroundColor: methodBackogrundColors[code] || theme.palette.button.default,
  }),
  value: {
    color: theme.palette.primary.darker,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0,
    paddingTop: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.button.default}`,
  },
  sectionLabel: {
    color: theme.palette.primary.light,
  },
  posted: {
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: 0,
    marginRight: theme.spacing(-1.5),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    borderTop: `1px solid ${theme.palette.button.default}`,
  },
  actionGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    // DESIGN.md §9: row actions are touch-sized (~44px) on the card presentation.
    '& button': {
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
    },
  },
  edit: {
    color: theme.palette.success.main,
  },
}));
